import { commonApi, OffsetLimit, StatusPagesResponse, StatusResponse } from './api';
import { AccountListElement, UserProfileMinimal } from './users_v1';


export enum TRANSCODING_STATE_ID {
    CREATED = 1, // "created")
    PROCESSED = 2, // "processed")
    CONVERTED = 3, // "converted")
    PACKED = 4, // "packed")
    FINISHED = 5, // "finished")
    FAILED = 6, // "failed")
}

export enum TRANSCODING_STATE {
    CREATED = 'created',
    PROCESSED = 'processed',
    CONVERTED = 'converted',
    PACKED = 'packed',
    FINISHED = 'finished',
    FAILED = 'failed',
}

export interface TranscodingOutput {
    ac: number,
    fit: boolean,
    level: number,
    width: number,
    height: number,
    preset: string,
    bufsize: string,
    maxrate: string,
    minrate: string,
    profile: string,
    filename: string,
    muxdelay: number,
    one_pass: boolean,
    frame_rate: boolean,
    thumbnails?: {
        exact: boolean,
        times: string[],
        presets: {
            big: string,
            small: string
        }
    },
    'x264-params': string,
    audio_bitrate: number,
    video_bitrate: number,
    full_processing?: boolean,
}

export interface TranscodingOutputStream {
    type: string,
    streams: Array<{ path: string, bandwidth: number }>
    filename: string
}

export interface TranscodingProlile {
    id: number,
    name: string,
    data: {
        outputs: Array<TranscodingOutput | TranscodingOutputStream>
    },
    updated: string
}

export interface WebcoderTaskResponse {
    id: string, // - идентификатор задачи
    module: ModuleType, // - название модуля
    added: string, // '2026-06-26T23:13:54.899185+03:00',
    updated: string, // '2026-06-26T23:17:35.684664+03:00',
    status: ModuleTaskStatus, // - системный статус задачи
    state: TRANSCODING_STATE, // - статус как есть из внешнего источника
    user: { // - пользователь, создавший задачу
        id: number, // - идентификатор пользователя (в мдиск)
        user: Pick<UserProfileMinimal, 'id' | 'email' | 'firstname' | 'lastname' | 'surname' | 'nickid'> & { avatar: string }, //     - инфа о пользователе
        account: AccountListElement, // - инфа о аккаунте
    },
    metadata: { // - метаданные задачи (вроде как не используем пока)
        jobid: number
    },
    args: WebcoderArgs, //  - аргументы, передаваемые модулю
    log: ModuleLogMessage[], //        - Логи выполнения задачи
}

export enum ModuleTaskStatus {
    CREATED = 0,
    STARTED = 10,
    QUEUED = 20,
    RUNNING = 30,
    PAUSED = 40,
    COMPLETED = 50,
    FAILED = 60,
}

export type ModuleType = 'webcoder';

export interface ModuleLogMessage {
    added: string, // '2026-06-26T23:14:41.117786+03:00',
    message: string, // 'Возникла ошибка при обработке заданных параметров: \'profile\'',
    level: 'INFO' | 'ERROR'
}

export interface WebcoderArgs { // - параметры для модуля
    source: string, // "account169/mv.mp4", - исходный файл
    target: string, // "account169/Transcoding/mv_demo_23r432.mp4", - результирующий файл, если в результате транскодирования будет один файл - нужно указать название файла, если нет - префикс директории
    'module-config': {
        preset?: number | string, // - Если нужно выполнить транскодирование по предопределенному системному профилю, нужно указать preset
        profile?: { //  - Если нужно кастомное транскодирование - указываем настройки в profile
            'outputs': WebcoderOutParams[] // - Параметры транскодирования (по идее описаны в /be/api/v1/integrted/modules/webcoder/:settings[]->parameters)
        }
    }
}

export interface WebcoderOutParams {
    ac: number,
    ar: number,
    pad: boolean,
    level: number,
    width: number,
    height: number,
    preset: string,
    volume: string,
    profile: string,
    filename: string,
    muxdelay: number,
    one_pass: boolean,
    frame_rate: number,
    audio_codec: string,
    video_codec: string,
    audio_bitrate: number,
    video_bitrate: number,
    full_processing: boolean
}

export interface WebcoderTask {
    module: ModuleType, // - module.label, название модуля
    metadata: object, // - пока не используется, передавай {}
    args: WebcoderArgs,
}

export interface WebcoderPreset {
    id: number,
    label: string,
    name: string,
    meta: {
        single_output: boolean,
        default_output_extension: string,
        have_default_output_extension: boolean
    },
    parameters: {
        outputs: WebcoderOutParams[]
    }
}

export const transcodeApi = commonApi.injectEndpoints({
    endpoints: (builder) => ({
        // это должны скачивать по прямой ссылке
        // getTranscodeArchive: builder.query<void, { contentId: number, mediaId: number, transcodedId: number }>({
        //     query: ({ contentId, mediaId, transcodedId }) => `be/api/content/${contentId}/media/${mediaId}/transcoded/${transcodedId}/`,
        // }),
        // createTranscodeTask: builder.mutation<TranscodingTaskResponse, { mediaUrl: string, profileId: number }>({
        //     query({ mediaUrl, profileId }) {
        //         return {
        //             url: `${mediaUrl}transcode/`,
        //             method: 'POST',
        //             body: { profile_id: profileId }
        //         };
        //     },
        // }),
        // getTranscodingTasks: builder.query<StatusPagesResponse<TranscodingTaskResponse>, OffsetLimit>({
        //     query: (params) => `be/api/content/transcoding/requests/?${Object.keys(params).filter(k => params[k]).map(k => params[k].toString().split(',').map(mk => k + '=' + mk).join('&')).join('&')}`,
        // }),
        // getTranscodeProfiles: builder.query<StatusPagesResponse<TranscodingProlile>, void>({
        //     query: () => 'be/api/content/transcoding/profiles/',
        // }),

        // /be/api/content/<id>/media/<mediaid>/transcode/     - [POST] создать задачу на транскодирование файла
        // /be/api/content/transcoding/requests/               - Список задач пользователя на транскодирование файлов
        // /be/api/content/transcoding/profiles/               - Список доступных профайлов для транскодирования
        getModulesAuditLog: builder.query<StatusPagesResponse<ModuleLogMessage>, { search?: string }>({
            query: ({ search }) => `be/api/v1/integrated/modules/audit/${search ? `?search=${search}` : ''}`,
        }),
        createWebcoderTask: builder.mutation<StatusResponse<WebcoderTaskResponse>, WebcoderArgs>({
            query(data) {
                return {
                    url: 'be/api/v1/integrated/modules/tasks/',
                    method: 'POST',
                    body: {
                        module: 'webcoder',
                        metadata: {},
                        args: data
                    }
                };
            },
        }),
        getTranscodingTasks: builder.query<StatusPagesResponse<WebcoderTaskResponse>, OffsetLimit>({
            query: (params) => `be/api/v1/integrated/modules/tasks/?${Object.keys(params).filter(k => params[k]).map(k => params[k].toString().split(',').map(mk => k + '=' + mk).join('&')).join('&')}`,
        }),
        getTranscodingTask: builder.query<StatusResponse<WebcoderTaskResponse>, string>({
            query: (id) => `be/api/v1/integrated/modules/tasks/${id}/`,
        }),
        getWebcoderProfiles: builder.query<StatusResponse<WebcoderPreset[]>, void>({
            query: () => 'be/api/v1/integrated/modules/webcoder/presets/',
        }),
    }),
});

export const {
    useCreateWebcoderTaskMutation,
    useGetWebcoderProfilesQuery,
    useGetTranscodingTaskQuery,
    useGetTranscodingTasksQuery,
    useGetModulesAuditLogQuery,
    useLazyGetWebcoderProfilesQuery,
    useLazyGetTranscodingTaskQuery,
    useLazyGetTranscodingTasksQuery,
    useLazyGetModulesAuditLogQuery,
} = transcodeApi;
